import React, { useRef } from 'react';
import { Formik, Field } from 'formik';
import useFormRutine from '../../../../../hooks/useForm';
import { InputField } from '../../../../../components/formFields/InputField';
import * as Yup from 'yup';
import { AreaField } from '../../../../../components/formFields/AreaField';
import { DatePickerField } from '../../../../../components/formFields/DatePickerField';
import { validDate } from '../../../../../utils/time';
import { CheckboxField } from '../../../../../components/formFields/Checkbox';

interface EtapeFormProps {
  formProps: any;
  submitOutside: any;
  submit: (values: any) => void;
  error?: any;
  reset?: boolean;
  resetConfirm?: any;
}

const EtapeForm = ({
  formProps,
  submitOutside,
  submit,
  error,
  reset = false,
  resetConfirm,
}: EtapeFormProps) => {
  const formRef = useRef();

  useFormRutine(formRef, submitOutside, reset, formProps, resetConfirm, error);

  const init = ({
    building_title,
    description,
    title,
    is_active,
    is_owned_by_my_company,
    is_physically_realized,
    created,
    finished,
  }: any = {}) => ({
    building_title,
    description,
    title,
    is_active,
    is_owned_by_my_company,
    is_physically_realized,
    created: created,
    finished: finished,
  });

  const validationSchema = Yup.object().shape({
    title: Yup.string().required('Povinné pole'),
    building_title: Yup.string().required('Povinné pole'),
    description: Yup.string().required('Povinné pole'),
    created: Yup.string().required('Povinné pole'),
    finished: Yup.string().required('Povinné pole'),
    is_owned_by_my_company: Yup.boolean(),
    is_physically_realized: Yup.boolean(),
    is_active: Yup.boolean(),
  });

  return (
    <div>
      <Formik
        innerRef={formRef}
        validationSchema={validationSchema}
        enableReinitialize={true}
        initialValues={init(formProps)}
        onSubmit={(values) => {
          submit(values);
        }}
      >
        {(props) => {
          const { values, setFieldValue } = props;
          return (
            <div className="space-y-1">
              <Field
                name="title"
                value={values.title}
                placeholder="Název etapy"
                component={InputField}
                disabled={!formProps.is_owned_by_my_company}
                label="Název etapy"
                data-testid="etape-form-title-input"
              />
              <Field
                name="building_title"
                value={values.building_title}
                placeholder="Název stavby"
                component={InputField}
                disabled={!formProps.is_owned_by_my_company}
                label="Název stavby"
                data-testid="etape-form-building-title-input"
              />
              <Field
                name="description"
                value={values.description}
                placeholder="Popis etapy"
                component={AreaField}
                disabled={!formProps.is_owned_by_my_company}
                label="Popis etapy"
                data-testid="etape-form-description-input"
              />

              <Field
                name="created"
                value={validDate(values.created)}
                placeholder="Vytvořeno"
                component={DatePickerField}
                onChange={(date: any) => setFieldValue('created', date)}
                disabled={!formProps.is_owned_by_my_company}
                label="Vytvořeno"
                data-testid="etape-form-created-input"
              />
              <Field
                name="finished"
                value={validDate(values.finished)}
                placeholder="Dokončeno"
                component={DatePickerField}
                onChange={(date: any) => setFieldValue('finished', date)}
                disabled={!formProps.is_owned_by_my_company}
                label="Dokončeno"
                data-testid="etape-form-finished-input"
              />

              <div className="flex gap-1 w-full px-4 justify-center">
                <div className="flex-1">
                  <Field
                    name="is_active"
                    value={values.is_active}
                    placeholder="Aktivní"
                    component={CheckboxField}
                    disabled={!formProps.is_owned_by_my_company}
                    label="Aktivní"
                    data-testid="etape-form-is-active-checkbox"
                  />
                </div>

                <div className="flex-1">
                  <Field
                    name="is_physically_realized"
                    value={values.is_physically_realized}
                    placeholder="Realizováno"
                    component={CheckboxField}
                    disabled={!formProps.is_owned_by_my_company}
                    label="Realizováno"
                    data-testid="etape-form-is-realized-checkbox"
                  />
                </div>

                <div className="flex-1">
                  <Field
                    name="is_owned_by_my_company"
                    value={values.is_owned_by_my_company}
                    placeholder="Firma je vlastníkem"
                    component={CheckboxField}
                    disabled={!formProps.is_owned_by_my_company}
                    label="Firma je vlastníkem"
                    data-testid="etape-form-is-owned-checkbox"
                  />
                </div>
              </div>
            </div>
          );
        }}
      </Formik>
    </div>
  );
};

export default EtapeForm;
